export const GRAPHQL_API_PATHNAME = '/poker/activegames/v1/graphql';
